import { useState, useRef } from 'react';
import { Button, Col, Row, Descriptions} from 'antd';
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons';
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from 'react-redux';

import { TruckingModal } from '@operations/shared';
import helper from '../../utils/helper';
import { getDataSheet, move } from '../../stores/actions';
interface IRootState {
    [key: string]: any;
    step: number,
}
const UploadVipUsersSheet = () => {
    const dispatch = useDispatch();
    const step: any = useSelector<IRootState>(state => state.truckingReducer.step);
    const [viewInstructions, setViewInstructions] = useState(false);
    const [validationErrors, setValidationErrors] = useState<string>();
    const [validFiles, setValidFiles] = useState(false);
    const userData = [
        { name: 'User ID', value: 'User ID is mandatory and must be unique' },
        { name: 'Start Date', value: 'Start Date is mandatory' },
        { name: 'End Date', value: 'End Date is mandatory' },
        { name: 'Free Deductions', value: 'Free Deductions is mandatory.' },
        { name: 'Minimum Installments', value: 'Minimum Installments is mandatory.' },
    ]
    const requiredColumns = [
        "userId",
        "startDate",
        "endDate",
        "freeDeductions",
        "minimumInstallments"
    ];
    const fileInputRef = useRef<HTMLInputElement>(null);
    const instructions = <>
        <div className="validation validation-en">
            <Descriptions
                bordered
                size={'small'}
                column={1}
            >
                {userData.map((data, index) => {
                    return <Descriptions.Item span={1} key={index} label={data.name}>{data.value}</Descriptions.Item>
                })}
            </Descriptions>
            <Row className='cancelInstructionContainer'>
                <Button className='mt-5 ant-btn-primary' onClick={() => setViewInstructions(false)}>Cancel</Button>
            </Row>
        </div>
    </>
    const validateColumns = (rows: any[]) => {
        if (!rows.length) return { valid: false, error: "The file must not be empty" };

        const fileColumns = Object.keys(rows[0]);

        const missing = requiredColumns.filter(col => !fileColumns.includes(col));
        const extra = fileColumns.filter(col => !requiredColumns.includes(col));

        if (missing.length > 0) {
            return { valid: false, error: `Missing required columns: ${missing.join(", ")}` };
        }

        if (extra.length > 0) {
            return { valid: false, error: `Unexpected columns found: ${extra.join(", ")}` };
        }

        return { valid: true };
    };
    const cancelInstructionsModal = () => {
        setViewInstructions(false)
    }
    const saveFile = () => { };

    const forwardClickToInputElement = () => {
        fileInputRef.current!.click();
    };
    const handleFile = (file: any) => {
        let file_size = file.size / (1024 * 1024), maxSize = 12, size;
        if (file.size < 1024) {
            size = file.size + ' B';
        } else if (file.size < (1024 * 1024)) {
            size = Math.floor(file.size / 1024) + ' KB';
        } else {
            size = Math.floor(file.size / (1024 * 1024)) + ' MB';
        }
        console.log(size);

        // /* Boilerplate to set up FileReader */
        let acceptable_exe = helper.regexValidation.xlsxCsvRegex;
        if (!acceptable_exe.exec(file.name)) {
            setValidFiles(true);
        } else if (file_size > maxSize) {
            setValidFiles(true);
            // return Upload.LIST_IGNORE
        } else {
            setValidFiles(false);
            let fileReader = new FileReader(), rowObject: any, result, workbook: XLSX.WorkBook;
            fileReader.readAsBinaryString(file);
            fileReader.onload = (event: any) => {

                result = event.target.result;
                workbook = XLSX.read(result, { type: "binary", cellDates: true });
                workbook.SheetNames.forEach(sheet => {
                    rowObject = helper.sheetToJson(workbook.Sheets[sheet]);
                });

                const validation = validateColumns(rowObject);
                if (!validation.valid) {
                    setValidationErrors(validation.error);
                    return;
                }
                const newRowObj = Array.isArray(rowObject) && rowObject.map((user: any) => {
                    return user
                });

                dispatch(getDataSheet({ sheetData: newRowObj }))
                dispatch(move(step + 1));
            }
        }
    }
    const handleFileChange = (e: { target: { files: any, value: any }; }) => {
        const files = e.target.files;
        setValidationErrors("");
        if (files && files[0]) handleFile(files[0]);
        e.target.value = null;
    }
    return (
        <>
            <div className="instructions">
                <Row>
                    <Col xl={18} md={18} sm={18}>
                        <p className="head">Before uploading, download the following form in order to fill in the required data and then re-upload it to the system</p>
                        <div className='mt-3 flex items-center gap-2' onClick={() => setViewInstructions(true)}>
                            <ExclamationCircleOutlined className='fillData' />
                            <p className='fillData'><span className='fillHint'>How to fill in the form data?</span></p>
                        </div>
                    </Col>
                    <Col xl={6} md={6} sm={6}>
                        <Button className='sample' onClick={saveFile}>Download the model file</Button>
                    </Col>
                </Row>
            </div>
            <div className='upload' onClick={forwardClickToInputElement}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">Click here to upload the file</p>
                <p className="ant-upload-hint">Supports single file upload</p>
                {validFiles && <p className="error-hint">{'Allowed extension CSV or XLS up to 12 MB'}</p>}
            </div>
            <span className="maxSize">The recommended size is up to 12MB</span>
            {validationErrors && <p className="text-red-600">{validationErrors}</p>}
            <form className="form-inline">
                <div className="form-group">
                    <label htmlFor="file"></label>
                    <input
                        hidden
                        type="file"
                        className="form-control"
                        id="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        accept='.xlsx,.xls,.csv'
                    />
                </div>
            </form>
            <TruckingModal visibleModal={viewInstructions}
                content={instructions}
                handleCloseModal={cancelInstructionsModal} title={'How to fill users sheet'} />
        </>
    )
}

export default UploadVipUsersSheet